"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ResizableColumn = _interopRequireDefault(require("./ResizableColumn"));

var _utils = require("../../../utils");

require("../styles/_resizable-column-container.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ResizableColumnContainer = /*#__PURE__*/function (_Component) {
  _inherits(ResizableColumnContainer, _Component);

  var _super = _createSuper(ResizableColumnContainer);

  function ResizableColumnContainer() {
    var _this;

    _classCallCheck(this, ResizableColumnContainer);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "handleResize", function (e) {
      var x = e.clientX;
      var _this$props = _this.props,
          minLeft = _this$props.minLeft,
          minRight = _this$props.minRight;
      var container = document.querySelector('.resizable-column-container');

      if (!container) {
        return;
      }

      var containerWidth = container.offsetWidth;
      var containerLeft = container.getBoundingClientRect().left;
      var newLeftWidth = x - containerLeft;
      var newRightWidth = containerWidth - newLeftWidth;

      if (newLeftWidth < minLeft || newRightWidth < minRight) {
        return;
      }

      _this.setState({
        containerSplit: {
          left: "".concat(newLeftWidth / containerWidth * 100, "%"),
          right: "".concat(newRightWidth / containerWidth * 100, "%")
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "startDrag", function () {
      document.addEventListener('mousemove', _this.handleResize);
      document.addEventListener('mouseup', _this.stopDrag);

      _utils.globalCursor.set('col-resize');
    });

    _defineProperty(_assertThisInitialized(_this), "stopDrag", function () {
      document.removeEventListener('mousemove', _this.handleResize);
      document.removeEventListener('mouseup', _this.stopDrag);

      _utils.globalCursor.reset();
    });

    _this.state = {
      containerSplit: {
        left: 'calc(50% - 25px)',
        right: 'calc(50% - 25px)'
      }
    };
    return _this;
  }

  _createClass(ResizableColumnContainer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          leftProps = _this$props2.leftProps,
          rightProps = _this$props2.rightProps,
          className = _this$props2.className,
          preventResize = _this$props2.preventResize;
      var containerSplit = this.state.containerSplit;
      return (/*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('resizable-column-container', className)
        }, /*#__PURE__*/_react.default.createElement(_ResizableColumn.default, _extends({}, leftProps, {
          width: containerSplit.left
        }), Array.isArray(children) ? children[0] : children), !preventResize ? /*#__PURE__*/_react.default.createElement("div", {
          className: "resizable-column-container__resizer",
          role: "button",
          tabIndex: 0,
          onMouseDown: this.startDrag
        }) : null, Array.isArray(children) && children[1] ? /*#__PURE__*/_react.default.createElement(_ResizableColumn.default, _extends({}, rightProps, {
          width: containerSplit.right
        }), children[1]) : null)
      );
    }
  }]);

  return ResizableColumnContainer;
}(_react.Component);

exports.default = ResizableColumnContainer;

_defineProperty(ResizableColumnContainer, "defaultProps", {
  minLeft: 300,
  minRight: 400
});